import React, { useContext, useEffect, useState } from 'react';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_Dropdown_New from '../ERUMAUI/UI_Dropdown_New';
import UI_LinearGroup from '../ERUMAUI/UI_LinearGroup';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Input_Time from '../ERUMAUI/UI_Input_Time';
import UI_Input_Date from '../ERUMAUI/UI_Input_Date';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';

export default function Controls_Map_Selector({
    children,
    Room_Show,
    Room_Selectable,
    NoTime,
    Direction,
    Labels,
    Form,
    Absolute,
    Required,
    onRoomSelect
}) {
    const UI = useContext(Context_UI);
    const {
        Selected_Building_Set,
        Selected_Building,
        Selected_Floor_Set,
        Selected_Floor,
        Selected_Room_Set,
        Selected_Room,
        Map_Time_Parameters_Update,
        Map_Time_Parameters,
        Information_Display,
        Map_Information,
        Map_Information_Type,
        Map_Composition
    } = useMapRenderer();

    const [Floors, Floors_Set] = useState([]);
    const [Rooms, Rooms_Set] = useState([]);

    const Buildings = Array.isArray(Map_Composition) ? Map_Composition : [];

    const HandleSelectBuilding = (Building) => {
        const buildingIndex = Buildings.findIndex(b => b._id === Building._id);
        Selected_Building_Set(buildingIndex);
        Selected_Floor_Set(null);
        Selected_Room_Set(null);
        Floors_Set(Building?.Floors || []);
        Rooms_Set([]);
    };

    const HandleSelectFloor = (Floor) => {
        const floorIndex = Floors.findIndex(f => f._id === Floor._id);
        Selected_Floor_Set(floorIndex);
        Selected_Room_Set(null);
        Rooms_Set(Floor?.Rooms || []);
    };

    const HandleSelectRoom = (Room) => {
        const roomIndex = Rooms.findIndex(r => r._id === Room._id);
        Selected_Room_Set(roomIndex);

        if (Room_Show && Room_Selectable && typeof Information_Display === "function") {
            Information_Display("Room", Room._id);
            if (onRoomSelect) {
                onRoomSelect(Room._id);
            }
        }
    };

    useEffect(() => {
        if (Buildings.length > 0 && Selected_Building != null) {
            const Building = Buildings[Selected_Building];
            Floors_Set(Building?.Floors || []);

            if (Selected_Floor != null && Building.Floors?.[Selected_Floor]) {
                const Floor = Building.Floors[Selected_Floor];
                Rooms_Set(Floor?.Rooms || []);
            }
        }
    }, [Map_Composition, Selected_Building, Selected_Floor]);

    useEffect(() => {
        if (!Map_Information || !Map_Information_Type) return;
        if (!Array.isArray(Map_Composition) || Map_Composition.length === 0) return;

        // Helper: find indices safely
        const findById = (list, id) => list?.findIndex(i => i._id === id) ?? -1;

        if (Map_Information_Type === "Building") {
            const buildingIndex = findById(Map_Composition, Map_Information._id);
            if (buildingIndex !== -1) {
                Selected_Building_Set(buildingIndex);
                Floors_Set(Map_Composition[buildingIndex]?.Floors || []);
                Selected_Floor_Set(null);
                Rooms_Set([]);
                Selected_Room_Set(null);
            }
        }

        else if (Map_Information_Type === "Floor") {
            for (let b = 0; b < Map_Composition.length; b++) {
                const building = Map_Composition[b];
                const floorIndex = findById(building.Floors, Map_Information._id);
                if (floorIndex !== -1) {
                    Selected_Building_Set(b);
                    Floors_Set(building.Floors || []);
                    Selected_Floor_Set(floorIndex);
                    Rooms_Set(building.Floors[floorIndex]?.Rooms || []);
                    Selected_Room_Set(null);
                    break;
                }
            }
        }

        else if (Map_Information_Type === "Room") {
            for (let b = 0; b < Map_Composition.length; b++) {
                const building = Map_Composition[b];
                for (let f = 0; f < (building.Floors || []).length; f++) {
                    const floor = building.Floors[f];
                    const roomIndex = findById(floor.Rooms, Map_Information._id);
                    if (roomIndex !== -1) {
                        Selected_Building_Set(b);
                        Floors_Set(building.Floors || []);
                        Selected_Floor_Set(f);
                        Rooms_Set(floor.Rooms || []);
                        Selected_Room_Set(roomIndex);
                        break;
                    }
                }
            }
        }
    }, [Map_Information, Map_Information_Type]);

    const Handle_Change_Time = (Side, Value) => {
        setTimeout(() => {
            const Passed = UI.Input_Evaluate([
                {
                    Type: "Time_Range_Custom",
                    ID_Start: "Controls_Map_Selector_Time_Start",
                    ID_End: "Controls_Map_Selector_Time_End",
                    AC: "Past",
                    Prompt: "Invalid time"
                }
            ]);
            if (Passed) {
                Map_Time_Parameters_Update(Side, Value);
            }
        }, 1);
    }

    // useEffect(() => {
    //     Handle_Change_Time("Time_Start", "00:01");
    //     Handle_Change_Time("Time_End", Map_Time_Parameters.Time_End);
    // }, [])

    return (
        <div
            className='Controls_Map_Selector'
            Form={Form ? "Form" : undefined}
            Absolute={!Absolute ? "Disabled" : undefined}
        >
            <UI_LinearGroup Direction={Direction || "Row"} Gap="Gap" Wrap={true}>
                {/* 🏢 Building Selector */}
                <UI_Dropdown_New
                    id="Controls_Map_Selector_Building"
                    InitialTitle="Select Building"
                    Items={Buildings}
                    Item_Key="Name"
                    Selected={Buildings[Selected_Building] || null}
                    Label_Text={Labels ? "Building:" : ""}
                    Required={Required}
                    onSelect={HandleSelectBuilding}
                />

                {/* 🧱 Floor Selector */}
                <UI_Dropdown_New
                    id="Controls_Map_Selector_Floor"
                    InitialTitle={Floors.length > 0 ? "Select Floor" : "No floors available"}
                    Items={Floors}
                    Item_Key="Name"
                    Selected={Floors[Selected_Floor] || null}
                    Label_Text={Labels ? "Floor:" : ""}
                    Required={Required}
                    onSelect={HandleSelectFloor}
                />

                {/* 🚪 Room Selector */}
                {Room_Show && (
                    <UI_Dropdown_New
                        id="Controls_Map_Selector_Room"
                        InitialTitle={Rooms.length > 0 ? "Select Room" : "No rooms available"}
                        Items={Rooms}
                        Item_Key="Name"
                        Selected={Rooms[Selected_Room] || null}
                        Label_Text={Labels ? "Room:" : ""}
                        Required={Required}
                        onSelect={HandleSelectRoom}
                    />
                )}

                {/* ⏰ Date and Time */}
                {!NoTime && (
                    <>
                        <UI_Input_Date
                            id="Controls_Map_Selector_Date"
                            Value={Map_Time_Parameters.Date}
                            onChange={(e) => Map_Time_Parameters_Update("Date", e.target.value)}
                            Initial_Today={true}
                        />
                        {/* <UI_Input_Text
                            Input_Type='date'
                            id="Controls_Map_Selector_Date"
                            Value_Set_Enable={true}
                            Value={Map_Time_Parameters.Date}
                            onChange={(e) =>
                                Map_Time_Parameters_Update("Date", e.target.value)
                            }
                        /> */}
                        <UI_Input_Time
                            id="Controls_Map_Selector_Time_Start"
                            Value={Map_Time_Parameters.Time_Start}
                            onChange={(e) => Handle_Change_Time("Time_Start", e.target.value)}
                        />
                        <p className='General_Paragraph' style={{alignSelf: "center"}}>
                            to
                        </p>
                        <UI_Input_Time
                            id="Controls_Map_Selector_Time_End"
                            Value={Map_Time_Parameters.Time_End}
                            onChange={(e) => Handle_Change_Time("Time_End", e.target.value)}
                        />
                        {/* <UI_Input_Text
                            Input_Type='time'
                            id="Controls_Map_Selector_Time_Start"
                            Value_Set_Enable={true}
                            Value={Map_Time_Parameters.Time_Start}
                            onChange={(e) =>
                                Handle_Change_Time("Time_Start", e.target.value)
                            }
                        /> */}
                        {/* <UI_Input_Text
                            Input_Type='time'
                            id="Controls_Map_Selector_Time_End"
                            Value_Set_Enable={true}
                            Value={Map_Time_Parameters.Time_End}
                            onChange={(e) =>
                                Handle_Change_Time("Time_End", e.target.value)
                            }
                        /> */}
                    </>
                )}

                {children}
            </UI_LinearGroup>
        </div>
    );
}
